export enum TOASTR_TYPES {
  SUCCESS = "SUCCESS",
  ERROR = "ERROR",
}
